/* eslint-disable */
import { KNOWLEDGEBASE_DATA_FETCH_ERR, KNOWLEDGEBASE_DATA_FETCH_SUCCESS } from './actions';

const initialState = {
  knowledgebase: {},
  error: null,
};

const knowledgebaseReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case KNOWLEDGEBASE_DATA_FETCH_SUCCESS:
      return {
        ...state,
        knowledgebase: data,
        error: null,
      };
    case KNOWLEDGEBASE_DATA_FETCH_ERR:
      return {
        ...state,
        error: err,
      };
    default:
      return state;
  }
};

export { knowledgebaseReducer };

